import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../core'
import * as space from '../space'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    constraints: {
      min: { value: 0 },
    },
    context: core.dms.models.Attribute.Id.Context.from(space.RESOURCE.payload),
    description: 'Total area for this unit of space',
    isOptional: true,
    name: 'Area (sqft)',
    partialId: PartialId.Standard.create('sqft'),
    type: core.common.value.types.Intrinsic.Decimal,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
